import { Schema } from 'prosemirror-model';

export const nodes = {
  doc: {
    content: 'inline*',
  },

  text: {
    group: 'inline',
  },
};

export default new Schema({
  nodes,
});
